import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';

type Props = {
  driveId: string | null;
  childId?: string | null;
} | null;

export const useTransferFileToClientMutation = (props: Props) => {
  const { driveId, childId } = props ?? { driveId: null, childId: null };

  const {
    mutateAsync,
    error,
    isPending: isLoading,
  } = useMutation<{ data: unknown }, Error, string>({
    mutationFn: (clientId: string) =>
      api.post(`sharepoint-docs/drives/${driveId}/children/${childId}/transfer-to-afternoon`, {
        clientId,
      }),
  });

  const transferFile = async (clientId: string): Promise<void> => {
    if (driveId === null || childId === null) {
      notifyAndLogError(
        'This file cannot be transferred',
        "We don't have all the data needed to transfer this file",
        null,
      );
      return;
    }
    await mutateAsync(clientId);
  };

  return {
    transferFile,
    isLoading,
    error,
  };
};
